import type { PropsWithChildren } from 'react';

import classNames from 'classnames';

import StandardPage from 'src/app/components/Elements/Page/Standard';

import styles from './styles.module.scss';

/**
 * This will allow a fixed component to be placed at the bottom of the screen but positioned to appear
 * as if it is part of the logged in page flow.
 */
const FixedFloat = ({ className, children }: PropsWithChildren<{ className?: string }>) => {
  return (
    <div className={classNames(styles.component, className)}>
      <div className={styles.content}>
        <StandardPage>{children}</StandardPage>
      </div>
    </div>
  );
};

export default FixedFloat;
